import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";

export const Manufactoring = types
  .model({
    printPaperSize: types.maybeNull(types.number),
    printPaperLength: types.maybeNull(types.number),
    printPaperSP: types.maybeNull(types.number),
    frontPrintColor: types.maybeNull(types.number),
    frontPrintColorCode: types.maybeNull(types.string),
    frontPrintMatte: types.maybeNull(types.string),
    frontPrintOtherHandling: types.maybeNull(types.string),
    backPrintColor: types.maybeNull(types.number),
    backPrintColorCode: types.maybeNull(types.string),
    backPrintMatte: types.maybeNull(types.string),
    backPrintOtherHandling: types.maybeNull(types.string),
    foil: types.maybeNull(types.string),
    foilProcessingStandard: types.maybeNull(types.string),
    foilNote: types.maybeNull(types.string),
    shape: types.maybeNull(types.string),
    shapeFormingStandard: types.maybeNull(types.string),
    shapeNote: types.maybeNull(types.string),
    cut: types.maybeNull(types.string),
    cutStandard: types.maybeNull(types.string),
    cutNote: types.maybeNull(types.string),
    paste: types.maybeNull(types.string),
    pasteStandard: types.maybeNull(types.string),
    pasteNote: types.maybeNull(types.string),
    package: types.maybeNull(types.string),
    packageStandard: types.maybeNull(types.string),
    packageNote: types.maybeNull(types.string),
    standard: types.maybeNull(types.string),
    otherHandle: types.maybeNull(types.string),
    note: types.maybeNull(types.string),
    printStandard: types.maybeNull(types.string),
    handleDetail: types.maybeNull(types.string),
    frontPrintHandleWay: types.maybeNull(types.string),
    backPrintHandleWay: types.maybeNull(types.string),
    firstFullPaperSize: types.maybeNull(types.number),
    firstFullPaperLength: types.maybeNull(types.number),
    firstFullPaperPrintQuantity: types.maybeNull(types.number),
    secondFullPaperSize: types.maybeNull(types.number),
    secondFullPaperLength: types.maybeNull(types.number),
    secondFullPaperPrintQuantity: types.maybeNull(types.number),
    secondPrintPaperSize: types.maybeNull(types.number),
    secondPrintPaperLength: types.maybeNull(types.number),
    secondPrintPaperSP: types.maybeNull(types.number),
    paperOutputStandard: types.maybeNull(types.string),
    printNote: types.maybeNull(types.string),
    coatingStandard: types.maybeNull(types.string),
    acceptanceStandard: types.maybeNull(types.string),
  })
  .actions(withSetPropAction);

export interface IManufactoring extends Instance<typeof Manufactoring> {}
export interface IManufactoringProperties
  extends SnapshotIn<typeof Manufactoring> {}

export interface IUpdateManufactoring extends IManufactoringProperties {}
